import { useEffect, useState } from 'preact/hooks'

/** Whether a CSS media query matches, updated when it changes. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => matchMedia(query).matches)

  useEffect(() => {
    const list = matchMedia(query)
    const onChange = (): void => {
      setMatches(list.matches)
    }
    list.addEventListener('change', onChange)
    return () => {
      list.removeEventListener('change', onChange)
    }
  }, [query])

  return matches
}
